/**
 * Fetch JSON, throwing on any non-2xx response.
 *
 * Bare `fetch(url).then((r) => r.json())` silently hands an error envelope
 * (e.g. the `{ error }` body a 401/403/500 returns) back to react-query as
 * *success* data. Consumers then read a field that isn't there — the staging
 * crash was `data.solutions.filter(...)` on a `{ error }` body, i.e.
 * "Cannot read properties of undefined (reading 'filter')". Throwing here routes
 * the failure into react-query's `error` state so the UI shows a load error
 * instead of crashing. Mirrors the local `jsonFetch` idiom in the hooks.
 */
export async function jsonFetch<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, init);
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error ?? `Request failed: ${res.status}`);
  }
  return (await res.json()) as T;
}
